import * as XLSX from 'xlsx';
import moment from 'moment';
import { buildReportExportRows } from '../Reports/reportColumnAdapter';

function slugify(value) {
	return value
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');
}

/**
 * Builds the XLSX from the already-fetched, already-filtered in-memory
 * rows — no second server call, since currency filtering is client-side
 * anyway. Two sheets: the monthly summary the user just saw on screen,
 * and the row-level detail (same column set as the Reports xlsx export).
 */
export function generatePredictionFile(type, rows, months) {
	const summaryRows = months.map((m) => ({
		Mes: m.label,
		[type.labels.countUnit === 'cuotas' ? 'Cuotas' : 'Operaciones']: m.uyu.n + m.usd.n,
		'Monto $': Math.round(m.uyu.monto),
		'Monto US$': Math.round(m.usd.monto),
	}));
	const detailRows = buildReportExportRows(type.columnInfo, type.dataName, rows);

	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(summaryRows), 'Resumen mensual');
	XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(detailRows), 'Detalle de cuotas');
	const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
	const blob = new Blob([buffer], { type: 'application/octet-stream' });
	const filename = `prevision-${slugify(type.id)}-${moment.utc().format('YYYY-MM-DD')}.xlsx`;
	return { blob, filename, count: rows.length };
}
